import React from 'react';
import { connect } from 'react-redux';
import { PetPolicyInfoContent } from 'bff/models/member';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import { InsType } from 'constants/enums/insType.enum';
import { RouterSettings } from 'constants/models/routerSettings';
import commonService from 'utils/commonService';
import PolicyInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PolicyInfo';
import PaymentInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PaymentInfo';
import PetInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PetInfo';
import PolicyholderInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PolicyholderInfo';
import InsuredInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/InsuredInfo';
import InsuredContent from 'components/MemberCenter/PolicyInquiry/PolicyDetail/InsuredContent';
import { Column, TableData } from 'components/MemberCenter/PolicyInquiry/PolicyDetail/InsuredContent/MergeTable/types';
import { RootReducersState } from 'redux/reducers';
import { IProps, IState } from './types';

// 擴充表格的 View model
const campaignTable: TableData = {
  header: [
    {
      fieldName: 'planName',
      fieldText: '保險項目',
      className: 'desc',
      width: '25%',
      merge: true,
      tid: 'TID_Insurance_content_pet'
    },
    {
      fieldName: 'itemName',
      fieldText: '承保範圍',
      className: 'desc',
      width: '45%',
      merge: true,
      tid: 'TID_coverage',
      colSpan: 2
    },
    {
      fieldName: 'amt',
      fieldText: '方案一',
      className: 'value',
      width: '30%',
      merge: false,
      tid: ''
    }
  ],
  rows: [
    /** 範例 */
    // {
    //   rowIndex: 0,
    //   columns: [
    //     {
    //       fieldName: 'planName',
    //       fieldValue: '醫療費用',
    //       className: 'desc',
    //       rowSpan: 2,
    //       colSpan: 1
    //     },
    //     {
    //       fieldName: 'itemName',
    //       fieldValue: '門診費用',
    //       className: 'desc',
    //       rowSpan: 1,
    //       colSpan: 1
    //     },
    //     {
    //       fieldName: 'amt',
    //       fieldValue: '2,000',
    //       className: 'value',
    //       rowSpan: 1,
    //       colSpan: 1
    //     }
    //   ]
    // },
    // {
    //   rowIndex: 1,
    //   columns: [
    //     {
    //       fieldName: 'planName',
    //       fieldValue: '醫療費用',
    //       className: 'desc',
    //       rowSpan: 0,
    //       colSpan: 1
    //     },
    //     {
    //       fieldName: 'itemName',
    //       fieldValue: '住院費用',
    //       className: 'desc',
    //       rowSpan: 1,
    //       colSpan: 1
    //     },
    //     {
    //       fieldName: 'amt',
    //       fieldValue: '10,000',
    //       className: 'value',
    //       rowSpan: 1,
    //       colSpan: 1
    //     }
    //   ]
    // }
  ]
};

// 寵物險方案模板 (前端 Hard code)
const campaignStructure = [
  {
    id: 'AMOUNT1',
    fieldName: 'AMOUNT1OUTPATIENT',
    itemName: '門診費用',
    planName: '寵物醫療費用',
    subItemName: '每一保險事故保險金額',
    amt: 0
  },
  {
    id: 'AMOUNT10',
    fieldName: 'AMOUNT10OUTPATIENTAGG',
    itemName: '門診費用',
    planName: '寵物醫療費用',
    subItemName: '保險期間內累積最高賠償限額',
    amt: 0
  },
  {
    id: 'AMOUNT13',
    fieldName: 'DEDUCTIBLE1',
    itemName: '門診費用',
    planName: '寵物醫療費用',
    subItemName: '自負額',
    amt: 0
  },
  {
    id: 'AMOUNT2',
    fieldName: 'AMOUNT2INPATIENT',
    itemName: '住院費用',
    planName: '寵物醫療費用',
    subItemName: '每一保險事故保險金額',
    amt: 0
  },
  {
    id: 'AMOUNT11',
    fieldName: 'AMOUNT11INPATIENTAGG',
    itemName: '住院費用',
    planName: '寵物醫療費用',
    subItemName: '保險期間內累積最高賠償限額',
    amt: 0
  },
  {
    id: 'AMOUNT14',
    fieldName: 'DEDUCTIBLE2',
    itemName: '住院費用',
    planName: '寵物醫療費用',
    subItemName: '自負額',
    amt: 0
  },
  {
    id: 'AMOUNT3',
    fieldName: 'AMOUNT3SURGERY',
    itemName: '手術費用',
    planName: '寵物醫療費用',
    subItemName: '每一保險事故保險金額',
    amt: 0
  },
  {
    id: 'AMOUNT12',
    fieldName: 'AMOUNT12SURGERYAGG',
    itemName: '手術費用',
    planName: '寵物醫療費用',
    subItemName: '保險期間內累積最高賠償限額',
    amt: 0
  },
  {
    id: 'AMOUNT15',
    fieldName: 'DEDUCTIBLE3',
    itemName: '手術費用',
    planName: '寵物醫療費用',
    subItemName: '自負額',
    amt: 0
  },
  {
    id: 'AMOUNT5',
    fieldName: 'AMOUNT5TORT',
    itemName: '寵物侵權責任',
    planName: '寵物侵權責任',
    subItemName: '寵物侵權責任',
    amt: 0
  },
  {
    id: 'AMOUNT6',
    fieldName: 'AMOUNT6LOSTAD',
    itemName: '寵物協尋廣告費用',
    planName: '寵物協尋廣告費用',
    subItemName: '寵物協尋廣告費用',
    amt: 0
  },
  {
    id: 'AMOUNT7',
    fieldName: 'AMOUNT7BOARDING',
    itemName: '被保險人住院期間寄宿日額費用(每日)',
    planName: '被保險人住院期間寄宿日額費用(每日)',
    subItemName: '被保險人住院期間寄宿日額費用(每日)',
    amt: 0
  },
  {
    id: 'AMOUNT8',
    fieldName: 'AMOUNT8FUNERAL',
    itemName: '寵物喪葬費用',
    planName: '寵物喪葬費用',
    subItemName: '寵物喪葬費用',
    amt: 0
  },
  {
    id: 'AMOUNT9',
    fieldName: 'AMOUNT9REACQUIRE',
    itemName: '寵物重新取得費用',
    planName: '寵物重新取得費用',
    subItemName: '寵物重新取得費用',
    amt: 0
  }
];

class PolicyDetailPet extends React.Component<IProps, IState> {
  state: IState = {
    detailInfo: {
      POLICY_DATA: {
        BC_TYPE: '',
        APPLY_TIME: '',
        APPLY_NO: '',
        POLICY_NO: '',
        POLICY_STATUS: '',
        CONFLICT_STATUS: '',
        PAYMENT_STATUS: '',
        PROGRAM_ID: '',
        PRODID: '',
        POLICY_DELIVERY: ''
      },
      PET_DATA: {
        INJURY: '',
        INJURY_STATUS: '',
        OTHER_POLICY: '',
        PET_AGE_MM: '',
        PET_AGE_Y: '',
        PET_BDAY: '',
        PET_CHIP: '',
        PET_KIND: '',
        PET_NAME: '',
        PET_PIC: '',
        PET_POLICY_AGE: '',
        PET_SEX: '',
        PET_STERIL: '',
        PET_VACCINATION: '',
        PET_VAR_NAME: '',
        PET_VAR_NO: '',
        PET_VAR_TYPE: '',
        PET_WEIGHT: undefined
      },
      POLICY_INFO: {
        AMOUNT1OUTPATIENT: undefined,
        AMOUNT2INPATIENT: undefined,
        AMOUNT3SURGERY: undefined,
        AMOUNT4AGG: undefined,
        AMOUNT5TORT: undefined,
        AMOUNT6LOSTAD: undefined,
        AMOUNT7BOARDING: undefined,
        AMOUNT8FUNERAL: undefined,
        AMOUNT9REACQUIRE: undefined,
        AMOUNT10OUTPATIENTAGG: undefined,
        AMOUNT11INPATIENTAGG: undefined,
        AMOUNT12SURGERYAGG: undefined,
        DEDUCTIBLE1: undefined,
        DEDUCTIBLE2: undefined,
        DEDUCTIBLE3: undefined,
        END_DATE: '',
        PLAN_ID: '',
        PLAN_ID_TEXT: '',
        START_DATE: '',
        TOTAL_FEE: undefined
      },
      APPLICANT_DATA: {
        ADDRESS: {
          ADDRESS: '',
          AREA_ID: '',
          CITY_ID: '',
          FULL: '',
          POST_CODE: ''
        },
        BIRTHDAY: '',
        EMAIL: '',
        GENDER: '',
        ID: '',
        MOBILE: '',
        NAME: '',
        NATIVE: ''
      },
      INSURED_DATA: {
        ADDRESS: {
          ADDRESS: '',
          AREA_ID: '',
          CITY_ID: '',
          FULL: '',
          POST_CODE: ''
        },
        BIRTHDAY: '',
        EMAIL: '',
        GENDER: '',
        ID: '',
        MOBILE: '',
        NAME: '',
        NATIVE: ''
      },
      PAYMENT_DATA: {
        PAYMENT: '',
        PAY_EXPIRE: '',
        PAYER_NAME: '',
        PAYER_ID: '',
        CARD_NO: '',
        APPROVE_CODE: '',
        BANK_ID: '',
        BANK_NAME: '',
        BANK_ACCOUNT: '',
        TRANSACTION: '',
        AMOUNT: undefined
      }
    },
    insTypeId: ''
  }

  componentDidMount () {
    let detailInfoVal;
    let insTypeIdVal;
    if (this.props.history.location.state) {
      // 透過路由取得險種類別
      const { detailInfo, insTypeId }: any = this.props.history.location.state;
      console.log(detailInfo);
      detailInfoVal = detailInfo;
      insTypeIdVal = insTypeId;
    }
    if (!detailInfoVal || !insTypeIdVal) {
      this.props.history.replace(RouterSettings.MemberCenter.PolicyInquiry);
      return;
    }

    this.setState({
      detailInfo: { ...detailInfoVal },
      insTypeId: insTypeIdVal
    });
  }

  getCampaignTable () {
    let { POLICY_INFO } = this.state.detailInfo;
    POLICY_INFO = {
      ...POLICY_INFO,
      DEDUCTIBLE1: POLICY_INFO.DEDUCTIBLE1 === '' ? '-' : POLICY_INFO.DEDUCTIBLE1,
      DEDUCTIBLE2: POLICY_INFO.DEDUCTIBLE2 === '' ? '-' : POLICY_INFO.DEDUCTIBLE2,
      DEDUCTIBLE3: POLICY_INFO.DEDUCTIBLE3 === '' ? '-' : POLICY_INFO.DEDUCTIBLE3
    };

    // 更新方案名稱
    const campaignName = campaignTable.header.find(it => !it.tid);
    if (campaignName) {
      campaignName.fieldText = POLICY_INFO.PLAN_ID_TEXT;
    }
    this.convertTableVModel(campaignTable, POLICY_INFO);
    this.mergeTableCell(campaignTable);
    return campaignTable;
  }

  /**
   * @description 將投保內容轉成表格所需的 View model
   * @param POLICY_INFO 投保內容下行電文
   */
  convertTableVModel (table: TableData, POLICY_INFO: PetPolicyInfoContent) {
    table.rows = [];
    campaignStructure.reduce((acc, cur, index) => {
      // 取得對應欄位與數值，如 ['AMOUNT1OUTPATIENT', 2000]
      const plan = Object.entries(POLICY_INFO).find(([key, value]) => key === cur.fieldName);
      if (plan) {
        const cols: Column[] = [];
        // 根據 header 欄位，建立每行各欄位的資料
        table.header.reduce((accH, curH, headerIndex) => {
          const header = Object.entries(cur).filter(([key, value]) => key === curH.fieldName || (key === 'subItemName' && curH.fieldName === 'itemName'));

          if (header) {
            header.forEach(item => {
              const data = this.processTableCell(plan[1], item, headerIndex, curH.fieldName);

              accH.push(data);

              return accH;
            });
          }

          return accH;
        }, cols);
        // 加入單行資料
        acc.push({
          rowIndex: index,
          columns: cols
        });
      }
      return acc;
    }, table.rows);
  }

  /**
   * @description 處理描述資料
   */
  processTableCell (amount: string, header: [string, any], headerIndex: number, fieldName: string) {
    // 將描述資料填入
    let val = `${header[1]}`;
    let className = 'desc';
    // 若為 amt，則填入數值並調整樣式
    if (fieldName === 'amt') {
      val = commonService.thousandFormat(`${amount}`);
      className = 'value';
    }

    return {
      colIndex: headerIndex,
      fieldName,
      fieldValue: val,
      className,
      rowSpan: 1,
      colSpan: 1
    };
  }

  /**
   * @description 合併表格 Cell
   */
  mergeTableCell (table: TableData) {
    const { header, rows } = table;
    for (let i = 0; i < header.length; i++) {
      const curHeader = header[i];
      if (!curHeader.merge) continue;
      const curColName = curHeader.fieldName;
      // 垂直方向合併: 針對每行的某個 column 欄位計算需合併 rowSpan
      rows.map((row, rowIndex) => {
        const val = row.columns.find(col => col.fieldName === curColName)?.fieldValue;
        const sameRows = rows.filter(it => it.columns.find(it => it.fieldValue === val && it.fieldName === curColName));
        if (sameRows.length > 1 && sameRows[0].rowIndex === rowIndex) {
          // 被合併的 cell 不再需要處理 (rowSpan 已被標記為 0)
          sameRows.map((it, index) => {
            const col = it.columns.find(it => it.fieldName === curColName);
            if (col) {
              if (index === 0) col.rowSpan = sameRows.length;
              else col.rowSpan = 0;
            }
          });
        }
        // 水平方向合併: 計算單行需合併欄位的 colSpan
        row.columns.map((col, colIndex) => {
          const sameCols = row.columns.filter(it => it.fieldValue === col.fieldValue);
          // 被合併的 cell 不再需要處理 (colSpan 已被標記為 0)
          if (sameCols.length > 1 && sameCols[0].colIndex === colIndex) {
            sameCols.map((col, index) => {
              if (index === 0) {
                col.colSpan = sameCols.length;
              } else {
                col.colSpan = 0;
              }
            });
          }
        });
      });
    }
  }

  render () {
    const { POLICY_DATA, PET_DATA, APPLICANT_DATA, INSURED_DATA, POLICY_INFO, PAYMENT_DATA } = this.state.detailInfo;
    return (
      <div className={`policy-detail policy-detail--${InsTypeDefinesEN[InsType.Pet]}`}>
        <div className="template-container">
          <div className="template-content">
            <div className="policy-detail__content">
              {/* 保單資訊 */}
              {
                POLICY_DATA && (
                  <PolicyInfo {...POLICY_DATA} INS_TYPE_ID={InsType.Pet} />
                )
              }
              {/* 寵物資料 */}
              {
                PET_DATA && (
                  <PetInfo {...PET_DATA} />
                )
              }
              {/* 投保內容 */}
              {
                POLICY_INFO && (
                  <InsuredContent collapsible>
                    <InsuredContent.List
                      INS_TYPE_ID={this.state.insTypeId}
                      PET_START_DATE={POLICY_INFO.START_DATE}
                      PET_END_DATE={POLICY_INFO.END_DATE}
                    />
                    <InsuredContent.MergeTable
                      DATA={this.getCampaignTable()}
                      TOTAL_FEE={commonService.thousandFormat(`${POLICY_INFO.TOTAL_FEE}`)}
                    />
                  </InsuredContent>
                )
              }
              {/* 要保人資料 */}
              {
                APPLICANT_DATA && (
                  <PolicyholderInfo
                    {...APPLICANT_DATA}
                    ADDRESS={APPLICANT_DATA.ADDRESS.FULL}
                    InsTypeId={this.state.insTypeId}
                  />
                )
              }
              {/* 被保險人資料 */}
              {INSURED_DATA && (
                <InsuredInfo
                  InsTypeId={this.state.insTypeId}
                  DATA={[{
                    NATIVE: INSURED_DATA.NATIVE,
                    ID: INSURED_DATA.ID,
                    NAME: INSURED_DATA.NAME,
                    GENDER: INSURED_DATA.GENDER,
                    BIRTHDAY: INSURED_DATA.BIRTHDAY,
                    MOBILE: INSURED_DATA.MOBILE,
                    EMAIL_ADDR: INSURED_DATA.EMAIL,
                    ADDRESS: INSURED_DATA.ADDRESS.FULL
                  }]}
                />
              )}
              {/* 付款資訊 */}
              <PaymentInfo {...PAYMENT_DATA} />
            </div>
            <div className="policy-detail__controls">
              <button type="button" className="policy-detail__btn" onClick={() => this.props.history.push(RouterSettings.MemberCenter.PolicyInquiry)}>{commonService.getNameByLng(this.props.resources, 'TID_Back_to_policy_query')}</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state: RootReducersState) => {
  return {
    resources: state.resources
  };
};

export default connect(mapStateToProps)(PolicyDetailPet);
